export const load = () => ({
	title: 'How to Decide if Soundproof Curtains Are the Best Product for You',
	showTitle: true,
});
